import styled from 'styled-components';
/* eslint-disable max-lines */

export const ScrollContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: auto;
  scrollbar-width: none;
  gap: 20px;
`;
export const Title = styled.h2`
  font-size: 16px;
  line-height: 1.5;
  margin-bottom:5px;
  font-weight: 500;
  color: #323131;
`;

export const Banner = styled.img`
    width: 100%;
    height: 350px;
    border-radius: 15px;
    overflow: hidden;
    object-fit: cover;
    box-sizing: border-box;
`;

export const LabelContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  overflow-y: auto;
  scrollbar-width: none;
  gap: 20px;
`;

export const Label = styled.div`
    background-color: #E4E4E7;
    padding: 8px 10px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: fit-content;
`;

export const Address = styled.p`
    font-size: 14px;
    line-height: 1.7; 
    font-weight: 400;
    color: #1C1C1C; 
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 400;
  color: #52525B; 
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  min-height: 287px;
  width: 100%;
  border-radius: 15px;
  gap: 12px;
  background: #F4F4F5;
`;

export const LoaderTitle = styled.span`
  color: #1C1C1C;
  font-size: 14px;
  line-height: 1.7;
  text-align: center;
  font-weight: 400;
`;

export const StatusText = styled.span`
  font-size: 14px;
  line-height: 1.7;
  text-align: center;
  color: #52525B;
`;

export const StatusImage = styled.img`
  height: 100px;
  width: 100px;
  margin: 0 auto;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 15px;
  width: 100%;
  min-height: 287px;
  border-radius: 10px;
  gap: 12px;
  background: #F4F4F5;
`;

export const FormTitle = styled.span`
  color: #1C1C1C;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  gap: 12px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px; 
  background-color: #1c1c1c;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  flex:1;
  height: 40px;
  color: #FFF;
`;

export const ButtonLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px; 
  background-color: #1c1c1c;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  flex:1;
  height: 50px;
  color: #FFF;
`;

export const Input = styled.input<{ error?: string }>`
  width: 100%;
  height: 40px;
  min-width: 150px;
  border-radius: 8px;
  padding: 8px 10px;
  border: 2px solid #FFF;
  background: #FFF;
  color: #1C1C1C;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  box-sizing: border-box;
  flex: 1;
  position: relative;
  
  ${({ error }) => error && `
    border-color: red;
  `}
`;

export const Checkbox = styled.input`
  appearance: none;
  -webkit-appearance: none;
  width: 40px;
  height: 40px;
  border: 2px solid #1C1C1C;
  border-radius: 12px;
  background: #FFF;
  cursor: pointer;
  position: relative;

  &:checked {
    background: #1C1C1C;
    border-color: #1C1C1C;
  }
  
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 20px;
    border: solid #F4F4F5;
    border-width: 0 3px 3px 0;
    transform: translate(-50%, -50%) rotate(45deg);
    transition: border-color 0.2s ease;
  }

  &:checked::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 20px;
    border: solid #FFF;
    border-width: 0 3px 3px 0;
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &:focus {
    outline: none;
  }
`;

export const InputLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #1C1C1C;
  margin-bottom: 5px;
  display: block;
  margin-top: 10px;
`;

export const FormLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #1C1C1C;
  margin-bottom: 5px;
  display: block;
`;

export const FormText = styled.label`
  font-size: 14px;
  font-weight: 400;
  color: #1C1C1C;
  margin-bottom: 5px;
  display: block;
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  min-width: 270px;
  padding: 5px;
  border-radius: 8px;
`;

export const ActionContainerPrice = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  min-width: 270px;
  padding: 15px 5px;
  border-radius: 8px;
`;

export const TrashButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color:rgba(82, 82, 91, 0.42);
  border-radius: 20px;
  border: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  color: #FFF;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  min-width: 270px;
`;

export const SummaryContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;

export const CodeContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #F4F4F5;
`;

export const PersonTitle = styled.span`
  color: #1C1C1C;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
`;

export const CounterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
`;

export const CounterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px; 
  background-color: #C18244;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  width: 35px;
  height: 35px;
  color: #FFF;
`;
